import { Components, Theme } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

export const MuiInputBase: Components<Theme>['MuiInputBase'] = {
  defaultProps: {
    size: 'medium',
  },
  styleOverrides: {
    root: {
      variants: [
        {
          props: { size: 'small' },
          style: {
            '--half-x-padding-small':
              'calc((var(--input-height-small) - 18px) / 2)',
            '&:not(.MuiInputBase-multiline, .MuiSelect-select)': {
              height: 'var(--input-height-small)',
              input: {
                /* Mui default padding is too large for our input heights, so we remove it and set the input to the same height and rely on flex centering.
                 * input needs a height larger than the input text, as the input gets styling with a background on autofill by the browser
                 */
                paddingTop: 0,
                paddingBottom: 0,
                height: 'var(--input-height-small)',
              },
            },
            '&.MuiInputBase-multiline': {
              minHeight: 'var(--input-height-small)',
              /* On multiline inputs we need padding for multiple lines be spaced well, but the padding is on the wrapper and the textarea has a height (18px),
               * so we calculate half of the remaining space to have good spacing on top and bottom when input has more than one line of text.
               */
              paddingTop: 'var(--half-x-padding-small)',
              paddingBottom: 'var(--half-x-padding-small)',
            },
            '.MuiSelect-select': {
              paddingTop: 'var(--half-x-padding-small)',
              paddingBottom: 'var(--half-x-padding-small)',
            },
          },
        },
        {
          props: { size: 'medium' },
          style: {
            '--half-x-padding-medium':
              'calc((var(--input-height-medium) - 18px) / 2)',
            '&:not(.MuiInputBase-multiline, .MuiSelect-select)': {
              height: 'var(--input-height-medium)',
              input: {
                /* Mui default padding is too large for our input heights, so we remove it and set the input to the same height and rely on flex centering.
                 * input needs a height larger than the input text, as the input gets styling with a background on autofill by the browser
                 */
                paddingTop: 0,
                paddingBottom: 0,
                height: 'var(--input-height-medium)',
              },
            },
            '&.MuiInputBase-multiline': {
              minHeight: 'var(--input-height-medium)',
              /* On multiline inputs we need padding for multiple lines be spaced well, but the padding is on the wrapper and the textarea has a height (18px),
               * so we calculate half of the remaining space to have good spacing on top and bottom when input has more than one line of text.
               */
              paddingTop: 'var(--half-x-padding-medium)',
              paddingBottom: 'var(--half-x-padding-medium)',
            },
            '.MuiSelect-select': {
              paddingTop: 'var(--half-x-padding-medium)',
              paddingBottom: 'var(--half-x-padding-medium)',
            },
          },
        },
      ],
      font: scssVariables.FontBodyRegular,
      input: {
        '&::placeholder': {
          color: scssVariables.ColorBlack60,
        },
        '&.TextAlignRight.MuiInputBase-inputAdornedEnd': {
          /* Mui removes any right padding from the input when an end adornment is present,
           * however we align number inputs to the right and on autofill the browser adds a background to the input
           * so we add some padding back to have the text not stick to the edge of the background.
           * We add some negative margin to compensate for the added padding and prevent the text not looking fully right aligned anymore
           */
          paddingRight: scssVariables.SpacingUnitHalf,
          marginRight: `calc(${scssVariables.SpacingUnitHalf} * -1)`,
        },
      },
    },
  },
};
